import { Flex, View, tokens } from "@sapphire-react/core";
import { useEffect, useRef } from "react";
import type { ReactNode } from "react";
import { useScroll } from "../hooks";
import { colors } from "../styles/colors";

type Props = {
  children: ReactNode;
  focus?: boolean;
  isHidden?: boolean;
  withPadding?: boolean;
  withSeparator?: boolean;
  borderRadius?: string | number;
  backgroundColor?: string;
};

export function ResultLayout({
  children,
  focus,
  isHidden,
  withPadding = true,
  withSeparator = true,
  borderRadius = tokens.size.radiusSm.value,
  backgroundColor = colors.sand50,
}: Props) {
  const scroll = useScroll({ scrollTo: "start" });
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (focus) {
      scroll(divRef.current);
    }
  }, [scroll, focus]);
  return (
    // We need to display:none this, instead of not rendering it on mobile view, since for tracking to work
    // the loan application navigation button must exist right away, so that tracking scripts register it properly.
    //
    // TODO: Flex isHidden or UNSAFE_style doesnt work, gets overwriten with
    // display: flex, should be fixed soon -
    // https://jira.danskebank.com/browse/UC-3553
    <div
      style={{
        display: isHidden ? "none" : "block",
      }}
    >
      <Flex
        width={"100%"}
        ref={divRef}
        height={"100%"}
        paddingBottom={tokens.size.spacing2xl}
      >
        {withSeparator && (
          <View marginTop={{ base: 24, md: 32 }} marginBottom={0}>
            <View
              isHidden={{ base: true, xs: false }}
              width={1}
              height={"100%"}
              backgroundColor={tokens.color.borderSecondary.value}
            />
          </View>
        )}

        <View
          paddingLeft={withPadding ? { base: 12, sm: 16, md: 32 } : 0}
          paddingRight={withPadding ? { base: 12, sm: 16, md: 32 } : 0}
          paddingTop={withPadding ? { base: 24, md: 32 } : 0}
          marginBottom={{ base: 24, sm: 0 }}
          flexDirection={"column"}
          width={"100%"}
          height={"100%"}
          backgroundColor={backgroundColor}
          borderRadius={borderRadius}
          data-test-id={"results"}
        >
          {children}
        </View>
      </Flex>
    </div>
  );
}
